export const ASSET_IMAGES = '/images';
